import { apiClient } from "@/shared/api/client";

export type ExplainMoveAction =
  | "why_mistake"
  | "what_to_play"
  | "fit_patterns"
  | "opponent_mistake"
  | "opponent_move"
  | "missed_opportunity"
  | "position_plan"
  | "time_decision";

export interface ExplainMoveRequest {
  requestId?: string;
  gameId: string;
  moveNumber: number;
  san: string;
  fenBefore: string;
  fenAfter: string;
  isBlunder: boolean;
  isMistake: boolean;
  centipawnLoss: number;
  bestMoveSan: string | null;
  bestMoveFrom: string | null;
  bestMoveTo: string | null;
  action: ExplainMoveAction;
  playerColor: "w" | "b";
}

export interface ExplainMoveResponse {
  explanation: string;
  rule?: string;
  bestMoveSan: string | null;
  bestMoveFrom: string | null;
  bestMoveTo: string | null;
  fenBefore: string;
  playerColor: "w" | "b";
  action: ExplainMoveAction;
  moveNumber: number;
  san: string;
  createdAt: string;
  isNew: boolean;
  source?: "hybrid" | "deterministic";
}

export const explainMove = (req: ExplainMoveRequest, signal?: AbortSignal): Promise<ExplainMoveResponse> =>
  apiClient<ExplainMoveResponse>("/coach/explain-move", {
    method: "POST",
    body: JSON.stringify(req),
    signal,
  });
